module.exports = __webpack_public_path__ + "static/img/erp2.3dd5f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/erp2.png
// module id = WHkK
// module chunks = 1